<template>
<!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
    </ul>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Messages Dropdown Menu -->      
      
      <li class="nav-item">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>
      <li class="nav-item dropdown user-menu">
        <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
          <img :src="$store.state.authUser.photo || '@/assets/adminlte/img/avatar5.png'" class="user-image img-circle elevation-2" alt="">
          <span class="d-none d-md-inline">{{$store.state.authUser.name}}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <!-- User image -->
          <li class="user-header bg-primary">
            <img :src="$store.state.authUser.photo || '@/assets/adminlte/img/avatar5.png'" class="img-circle elevation-2" alt="">
            <p>
              {{$store.state.authUser.name}}
              <small>{{$store.state.authUser.email}}</small>
            </p>
          </li>
          <!-- Menu Footer-->
          <li class="user-footer">
            <button @click="lockScreen" class="btn btn-warning btn-social btn-sm"><i class="fas fa-lock"></i> Lock Screen</button>
            <button @click="logOut" class="btn btn-danger btn-social float-right btn-sm"><i class="fas fa-sign-in-alt"></i> Logout</button>
          </li>
        </ul>
      </li>
    </ul>

    <!-- Modal -->
    <div class="modal fade" id="modalLogin" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content lockscreen">
          <div class="lockscreen-wrapper">
            <div class="lockscreen-logo">
                <b>Alene</b>
            </div>

            <div class="lockscreen-name">{{$store.state.authUser.name}}</div>

            <div class="lockscreen-item">

              <div class="lockscreen-image">
                <img :src="$store.state.authUser.photo || '@/assets/adminlte/img/avatar5.png'">
              </div>

              <form class="lockscreen-credentials" id="frmLogin">
                <div class="input-group">
                  <input type="password" class="form-control validate[required, minSize[4]]" id="pswd" v-model="loginData.password" placeholder="Senha"/>
                  <div class="input-group-append">
                    <button type="button" class="btn" v-on:click="logIn">
                      <i class="fas fa-arrow-right text-muted"></i>
                    </button>
                  </div>
                </div>
              </form>

            </div>

            <div class="help-block text-center">
              Enter your password to unlock your session.
            </div>
            <div class="text-center">
              <a href="#" @click="logOut">Log in with a different user.</a>
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <!-- /.navbar -->
</template>

<script>
import SystemUserController from "@/controllers/system_user.controller";
import validator from "@/utils/validator";
import toastr from "@/utils/toastr";

export default {
  name: "Header",
  data: function() {
    return {
      loginData: {
        email: this.$store.state.email || null,
        password: null
      },
      userIntervalId: null,
    };
  },
  mounted(){
    this.startInterval();
  },
  beforeDestroy() {
    this.stopInterval();
  },
  methods: {
    startInterval()
    {
      const vm = this;

      vm.checkUser();

      this.userIntervalId = setInterval(function(){
        vm.checkUser();
      }, 20000);
    },
    stopInterval()
    {
      if (this.userIntervalId)
      {
        clearInterval(this.userIntervalId);
        this.userIntervalId = null;
      }
    },
    logIn: function() {
      if (!validator.isValid("#frmLogin"))
          return;

      SystemUserController.login(this.loginData)
        .then(response => {

          if(!response.data.success)
          {
            this.loginData.password = null;
            toastr.error(response.data.error);
            return;
          }          

          this.startInterval();

          this.$store.dispatch('setToken', response.data.result.accessToken)
          .then(() => {
            $('#modalLogin').modal('hide');
          });
        })
        .catch(e => {
          toastr.error(e);
        });
    },
    logOut: function() {
      this.$store.dispatch("logOut");
      location.href = '/';
    },
    lockScreen: function() {
      this.$store.dispatch("logOut");
      this.stopInterval();

      if(!$('#modalLogin').hasClass('show'))
      {
        this.loginData.password = null;

        $('#modalLogin')
        .appendTo("body")
        .modal({
          show: true,
          backdrop: 'static',
          keyboard: false
        });

        $('#modalLogin').on('shown.bs.modal', function () {
          $('#pswd').trigger('focus');
        });
      }
    },
    checkUser: function() {
        SystemUserController.check()
        .then(response => {
          if (!response)
          {
            this.lockScreen();
            return;
          }
          if(response.data.success)
            return;
        });
    }
  }
};
</script>

<style>
.nav-link {
  cursor: pointer;
}

.blink_me {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>

